const navPaths = {
  home: "/home",
  knowledgeBases: "/knowledge-bases",
  knowledgeBaseDetail: "/knowledge-bases/:id",
  knowledgeBaseDocument: "/knowledge-bases/:id/:docId",
  infoSynthesis: "/info-synthesis",
  /** For `<Route path={…} />` only. */
  infoSynthesisSession: "/info-synthesis/:sessionId",
  login: "/login",
  logout: "/logout",
} as const;

const toInfoSynthesisSessionPath = (sessionId: string) =>
  `${navPaths.infoSynthesis}/${sessionId}`

const buildDocumentPath = (kbId: string, docId: string): string =>
  `${navPaths.knowledgeBases}/${kbId}/${docId}`

export { navPaths, toInfoSynthesisSessionPath, buildDocumentPath }